import { UNASSIGNED_TALENT_POOL } from '../constants/talentPool';

/** 无字典条目时的展示名：仅处理未分配占位，其余直接显示 code。 */
export function getTalentPoolLabelLegacy(code: string | null | undefined): string {
  if (!code) return '-';
  if (code === UNASSIGNED_TALENT_POOL) return '未分配';
  return code;
}
